import {
	CLEAR_PROJECT_INSIGHTS_FILTERS,
	GET_INDUSTRIES_REPORT_FETCH,
	GET_INDUSTRIES_REPORT_SUCCESS,
	INSIGHTS_FILTERS_SELECTED_COMPANIES,
	SET_COUNTRY_REPORT,
	SET_ETHNIC_DIVERSITY_DATA,
	SET_FIT_TO_BRIEF_DATA,
	SET_GENDER_DIVERSITY_DATA,
	SET_INDUSTRIES_REPORT_FAILED,
	SET_JOB_FUNCTION_DISTRIBUTION_DATA,
	SET_JOB_FUNCTION_DISTRIBUTION_INIT,
	SET_PROJECT_INSIGHTS_FILTER_BY_KEY,
} from "store/mapXActionTypes";
import {STCompany} from "api/companyApi/types";

export function setGenderDiversityData<T>(payload: T) {
	return {type: SET_GENDER_DIVERSITY_DATA, payload};
}

export function getIndustriesReportFetch() {
	return {type: GET_INDUSTRIES_REPORT_FETCH};
}

export function getIndustriesReportFailed() {
	return {type: SET_INDUSTRIES_REPORT_FAILED};
}

export function setCountryReport<T>(payload: T) {
	return {type: SET_COUNTRY_REPORT, payload};
}

export function getIndustriesReportSuccess<T>(payload: T) {
	return {type: GET_INDUSTRIES_REPORT_SUCCESS, payload};
}

export function setEthnicDiversityData<T>(payload: T) {
	return {type: SET_ETHNIC_DIVERSITY_DATA, payload};
}

export function setFitToBriefData<T>(payload: T) {
	return {type: SET_FIT_TO_BRIEF_DATA, payload};
}

export function setJobFunctionDistributionData<T>(payload: T) {
	return {type: SET_JOB_FUNCTION_DISTRIBUTION_DATA, payload};
}

export function setJobFunctionDistributionInit() {
	return {type: SET_JOB_FUNCTION_DISTRIBUTION_INIT};
}

export function setProjectInsightsFilterByKey<T>(payload: {key: string; values: T}) {
	return {type: SET_PROJECT_INSIGHTS_FILTER_BY_KEY, payload};
}

export function clearProjectInsightsFilters() {
	return {type: CLEAR_PROJECT_INSIGHTS_FILTERS};
}

export function insightsFiltersSelectedCompanies(payload: STCompany[]) {
	return {type: INSIGHTS_FILTERS_SELECTED_COMPANIES, payload};
}
